import { render, staticRenderFns } from "./StatisticsEachReporter.vue?vue&type=template&id=38906029&"
import script from "./StatisticsEachReporter.vue?vue&type=script&lang=js&"
export * from "./StatisticsEachReporter.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsEachReporter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports